import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LocalStorageService } from '../local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class RouteTrackerService {

  private previousUrl: string | null = null;
  private currentUrl: string | null = null;


  constructor(private router: Router, private localStorage:LocalStorageService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
  
        // Store the current URL in localStorage
        this.localStorage.setItem('previousUrl', this.previousUrl || '/');
      }
    });
  }

  getPreviousUrl(): string | null {
    return this.previousUrl;
  }
}
